export const DEFAULT_DATEPICKER_FORMAT = 'dddd Do MMMM';
export const DATE_PICKER_FORMAT = 'YYYY-MM-DD';
export const DATE_WEEKDAY_FORMAT = 'long';
